
import headerLink from './tidal-header-link.vue';

export default {
    components: {
        headerLink,
    },
    inheritAttrs: false,
    props: {
        /** @type {import('vue').PropOptions<import('@tidal/styles-header').CurrentUser>} */
        user: {
            type: Object,
            required: true,
        },
        href: {
            type: String,
            required: true,
        },
        external: {
            type: Boolean,
            default: false,
        },
        isNuxt: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
};
